import loadable from '@loadable/component';

export const IntegrationsPageContainerLoadable = loadable(
  () => import('./IntegrationsPageContainer'),
  {
    resolveComponent: (module) => module.IntegrationsPageContainer,
  },
);
